import React, {useEffect } from 'react';
import Menu from "../include/Menu";
import Footer from "../include/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import IndexWrapper from "./IndexWrapper.js";
import TransactionStatus from "../TxnStatus";

const IndexSections = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true,  
    });
  }, []);
  return (
  <>
  <Menu />
  <IndexWrapper />
  <TransactionStatus />
  <Footer />
  </>
  );
};

export default IndexSections;